import Repository from '@/services/Repository';

const resource = '/dashboard';

const toDashboardCard = (item) => {
  return [
    {
      icon: 'mdi-hail',
      iconColor: 'teal',
      number: item.students,
      title: 'นักเรียน (คน)',
      path: 'students',
    },
    {
      icon: 'mdi-account-tie',
      iconColor: 'orange darken-3',
      number: item.users,
      title: 'บุคลากร (คน)',
      path: 'users',
    },
    {
      icon: 'mdi-google-classroom',
      iconColor: 'brown darken-1',
      number: item.classrooms,
      title: 'ห้องเรียน (ห้อง)',
      path: 'classrooms',
    },
  ];
};

export default {
  fetch() {
    return new Promise((resolve, reject) => {
      Repository.get(`${resource}/`)
        .then((response) => {
          let result = toDashboardCard(response.data);
          resolve(result);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
